export const CHROME_WEB_STORE = 'https://chrome.google.com/webstore/detail/untab/cijggohdciglnifgpobicololkdjihad';
export const FIREFOX_ADDON = 'https://addons.mozilla.org/en-US/firefox/addon/view-untab/';
export const EDGE_ADDON = 'https://microsoftedge.microsoft.com/addons/detail/untab/ncdglhpnlkomnfgpdeiokgnfolpbojge';
